// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0bd9420a","732":"fce7ddaf","977":"6b8f66ca"}[chunkId] + ".chunk.js";
};